import axiosInstance from "../instance/axiosInstance";

class AuthApi {
  static async login(credentials) {
    try {
      const response = await axiosInstance.post("/login", credentials);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async logout() {
    try {
      const response = await axiosInstance.get("/logout");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async signupStepOne(credentials) {
    try {
      const response = await axiosInstance.post(
        "/register-step-1",
        credentials
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async signupStepTwo(credentials) {
    try {
      const response = await axiosInstance.post(
        "/register-step-2",
        credentials,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async reqPasswordReset(email) {
    try {
      const response = await axiosInstance.post(
        "/password/reset-request",
        email
      );
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async resetPassword(formData) {
    try {
      const response = await axiosInstance.post("password/reset", formData);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async loginWithPhone(phone) {
    try {
      const response = await axiosInstance.post("/send-otp", phone);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async verifyOtp(queryData) {
    try {
      const response = await axiosInstance.post("/verify-otp", queryData);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getAuthenticatedUser() {
    try {
      const response = await axiosInstance.get("/get-authenticated-user");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getAllFeatures() {
    try {
      const response = await axiosInstance.get("/all-allowed-features");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getBankInfo() {
    try {
      const response = await axiosInstance.get("/platform-settings");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getInvoiceNumber() {
    try {
      const response = await axiosInstance.get("/invoice-number");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getPlanInfo(id, type) {
    let url = `/plan-detail/${id}`;
    if (type) {
      url += `?type=${type}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async getAllFeatures() {
    let url = `/all-allowed-features`;
    try {
      const response = await axiosInstance.get(url);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async checkPromo(code) {
    try {
      const response = await axiosInstance.get(`/check-promotion/${code}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
}

export default AuthApi;
